import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
// Model
import { RuleWorkFlow } from '../models/inline-rules.model';
import { RuleItemDirectiveDataModel, RuleItemDirectiveModel } from '../models/rule-item-directive.model';

@Injectable()
export class RulesChangeService {
	rulesDataChanged: Subject<any> = new Subject();
	rulesItems: RuleItemDirectiveModel = {};
	rulesWorkFlow: RuleWorkFlow;

	setRulesWorkflow(workflow: RuleWorkFlow): void {
		this.rulesWorkFlow = workflow;
	}

	/**
	 * Add item in the sections object if not exist.
	 * Check if the section exists, if not, create it.
	 * 
	 * @param section 
	 * @param element 
	 */
	addItem(itemId: string, itemData: RuleItemDirectiveDataModel): void {
		if (!(itemId in this.rulesItems)) {
			const nObj = [];
			nObj[itemId] = new RuleItemDirectiveDataModel();

			Object.assign(this.rulesItems, nObj);
		}

		Object.assign(this.rulesItems[itemId], itemData);
	}
}
